<template>
  <div>
    <div v-if="showBgFilter" class="verticallyCenter">
      <cx-check-box :value.sync="showBackgroundFilter">背景模糊</cx-check-box>
      <i class="tips-btn icon-portal-info2" @click.stop.prevent="explainDialog = true"></i>
    </div>
    <div class="mapping_content mt12" v-if="showBackgroundFilter">
      <slider-and-input :value.sync="backgroundFilter" title="" :sliderMax="250" suffix="px" />
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>开启背景模糊后：</span>可让元素的背景变模糊，就像加了磨砂玻璃效果，突出前景内容。背景颜色的透明度越低，效果越明显。
      </p>
      <div class="box">
        <img :src="explainImgSrc" alt="" class="img" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isExist } from "../../../utils/index"
export default {
  name: "publicSetting",
  props: {
    options: {
      type: Object,
      default: null
    },
    showBgFilter:{
      type: Boolean,
      default: true
    },
    ids: {
      type: Object
    },
  },
  data(){
    return {
      activeNames: ["0"],
      explainDialog: false,
      explainImgSrc: require("../../../assets/images/tipsVideoImg/bg-filter.png")
    }
  },
  computed: {
    showBackgroundFilter: {
      get() {
        return this.getOptions().showBackgroundFilter || false
      },
      set(newVal) {
        this.handleSet("showBackgroundFilter", newVal)
      }
    },
    backgroundFilter: {
      get() {
        return this.getOptions().backgroundFilter || 0
      },
      set(newVal) {
        this.handleSet("backgroundFilter", newVal)
      }
    }
  },
  mounted() {
  },
  methods: {
    getOptions() {
      if (!this.options) return {}
      const innerElement = this.options?.innerElement
      if (innerElement) return this.options
      else if (this.ids.uid) return this.options.componentBoxOptions
      else if (this.options?.options) return this.options?.options
      else return this.options
    },
    handleSet(key, val) {
      let ids = this.ids
      if (ids.hasOwnProperty("swiperContent_id")) delete ids.swiperContent_id
      let rectId = ids.rect_id
      let pageLayoutId = ids.pageLayoutId
      if (this.getOptions()?.isAccordionLayoutRow && isExist(rectId) && !isExist(pageLayoutId)) {
        this.$changeOptionsEV(
          val,
          key,
          false,
          undefined,
          {
            ...ids,
            pageLayoutId: "1_0"
          }
        )
      } else {
        this.$changeOptionsEV(val, key, false, null, ids)
      }
    }
  }
}
</script>

<style lang="scss">
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(251, 252, 253, 1)
}
.bigScreen {
  .mapping_content {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    background-color: rgba(40, 42, 46, 1);
  }
}
</style>